export default __webpack_public_path__ + "static/media/LeftArrow.cefc622e.svg";